import { render, staticRenderFns } from "./QuestionForm.vue?vue&type=template&id=18bea07f&scoped=true"
import script from "./QuestionForm.vue?vue&type=script&lang=ts"
export * from "./QuestionForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bea07f",
  null
  
)

export default component.exports